
import axios_instance  from "./ApiService";


class OrdersService {
    controllerName = '/Order';
    GetAllPendingByServicePlace(ServicePlaceId) {
        return axios_instance.get(this.controllerName + '/GetAllPendingOrdersForServicesPlace' , {params:{ServicePlaceId:ServicePlaceId}}).then(response =>{
            return Promise.resolve(response.data);
        });
    }

    GetCurrentOrders(payload) {
        return axios_instance.get(this.controllerName + '/GetAllDoneBranchOrdersOrPlaceOrders' , {params:payload}).then(response =>{
            return Promise.resolve(response.data);
        });
    }

    GetAllPendingUserOrders() {
    
        return axios_instance.get(this.controllerName + '/GetAllPendingUserOrders').then(response =>{
            return Promise.resolve(response.data);
        });
    }
    GetAllDoneUserOrders() {
        return axios_instance.get(this.controllerName + '/GetAllDoneUserOrders').then(response =>{
            return Promise.resolve(response.data);
        });
    }

    NewOrder(offerId, note) {
        return axios_instance.get(this.controllerName + '/NewOrder', { params: { OfferId: offerId, Note: note || '' } }).then(response => {
            return Promise.resolve(response.data);
        });
    }

    GetUserOrderById(orderId) {
        return axios_instance.get(this.controllerName + '/GetUserOrderById', { params: { OrderId: orderId } }).then(response => {
            return Promise.resolve(response.data);
        });
    }

    Approve(orderId) {
        return axios_instance.get(this.controllerName + '/Approve', { params: { OrderId: orderId } }).then(response => {
            return Promise.resolve(response.data);
        });
    }

    DisApprove(orderId) {
        return axios_instance.get(this.controllerName + '/DisApprove', { params: { OrderId: orderId } }).then(response => {
            return Promise.resolve(response.data);
        });
    }

    GetMessageDepositFromUserWallet(orderId) {
        return axios_instance.get(this.controllerName + '/GetMessageDepositFromUserWallet', { params: { OrderId: orderId } }).then(response => {
            return Promise.resolve(response.data);
        });
    }

    ApplyDepositFromUserWallet(orderId) {
        return axios_instance.get(this.controllerName + '/ApplyDepositFromUserWallet', { params: { OrderId: orderId } }).then(response => {
            return Promise.resolve(response.data);
        });
    }

    CancelDepositFromUserWallet(orderId) {
        return axios_instance.get(this.controllerName + '/CancelDepositFromUserWallet', { params: { OrderId: orderId } }).then(response => {
            return Promise.resolve(response.data);
        });
    }

    ScanOrderQrCode(OrderCode, BranchId) {
        return axios_instance.get(this.controllerName + '/ScanOrderQrCode', { params: { OrderCode, BranchId } }).then(response => {
            return Promise.resolve(response.data);
        });
    }
}
export default new OrdersService();